require("pixi-particles");

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {AnimatedParticle, Emitter} from "pixi-particles";

export class CoinsFountain extends BaseView {

    private readonly _screenHeightRange: [number, number] = [720, 1760];
    private readonly _startSpeedRange: [number, number] = [650, 950];
    private readonly _coinsConfigs: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.3,
                "end": 0.5,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 400,
                "end": 200,
                "minimumSpeedMultiplier": 2
            },
            "acceleration": {
                "x": 0,
                "y": 500
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 235,
                "max": 310
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 10,
                "max": 70
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "blendMode": "normal",
            "frequency": 0.02,
            "emitterLifetime": -1,
            "maxParticles": 50,
            "pos": {
                "x": 360,
                "y": 360,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -5,
                "y": 0,
                "w": 10,
                "h": 1
            }
        },
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.7,
                "end": 1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 600,
                "end": 300,
                "minimumSpeedMultiplier": 2
            },
            "acceleration": {
                "x": 0,
                "y": 1500
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 235,
                "max": 310
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 20,
                "max": 40
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "blendMode": "normal",
            "frequency": 0.06,
            "emitterLifetime": -1,
            "maxParticles": 80,
            "pos": {
                "x": 360,
                "y": 360,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -5,
                "y": 0,
                "w": 10,
                "h": 1
            }
        },
        {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.7,
                "end": 1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 700,
                "end": 350,
                "minimumSpeedMultiplier": 2
            },
            "acceleration": {
                "x": 0,
                "y": 1500
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 235,
                "max": 310
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 20,
                "max": 40
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "blendMode": "normal",
            "frequency": 0.1,
            "emitterLifetime": -1,
            "maxParticles": 100,
            "pos": {
                "x": 360,
                "y": 360,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -5,
                "y": 0,
                "w": 10,
                "h": 1
            }
        }
    ];

    private _coinsEmitters: Emitter[];
    private _layer: ScalableLayer;
    private _isPlaying: boolean = false;
    private _currentOrientation: Orientation;
    private _currentLevel: number = -1;

    constructor(layer: ScalableLayer) {
        super();
        this._layer = layer;
    }

    public startFountain(playLevel: number): void {
        this._currentLevel = playLevel;
        const shouldPlayStar: boolean = !this._isPlaying;
        this._isPlaying = true;

        this._coinsEmitters.forEach((emitter: Emitter, level: number) => {
            if (level < playLevel) {
                emitter.emit = true;
            }
        });
    }

    public stopFountain(): void {
        this._currentLevel = -1;
        this._isPlaying = false;
        this._coinsEmitters.forEach((emitter: Emitter) => {
            emitter.emit = false;
        });
    }

    protected initAnimations(): void {
        this._coinsEmitters = [];
        this.addEmitters();
    }

    private addEmitters(): void {
        this._coinsConfigs.forEach((config: any, level: number) => {
            const emitter: Emitter = new Emitter(this._layer, [{
                framerate: 30,
                loop: true,
                hasLoaded: true,
                textures: GameResources.getTextures(`bigWinCoin${level}`)
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._coinsEmitters.push(emitter);
        });
    }
}